module.exports = __webpack_public_path__ + "img/logo.64146e72.jpg";